import { Address, hexToBigInt, PublicClient } from 'viem';

import { IPFS_PREFIX } from 'modules/api/const';
import { getPoolOwnershipContract } from 'modules/api/contracts/getPoolOwnershipContract';
import { loadPoolIPFSData } from 'modules/api/methods/loadPoolIPFSData';
import { IPoolMeta } from 'modules/pool/types';
import { getIPFSHash } from 'modules/pool/utils';

const ipfsHashRegex = /[^/]+$/;

export async function getPoolMeta(
  client: PublicClient,
  poolAddress: Address,
  withQueue = true,
): Promise<IPoolMeta> {
  const ownerShipContract = await getPoolOwnershipContract({
    publicClient: client,
  });

  const metaRawURI = await ownerShipContract.read.tokenURI([
    hexToBigInt(poolAddress),
  ]);

  const hash = getIPFSHash(metaRawURI);
  const metaJson = await loadPoolIPFSData(poolAddress, hash, withQueue);

  const ipfsImage = (() => {
    const isIpfs = metaJson.image.startsWith(IPFS_PREFIX);
    if (isIpfs) {
      return metaJson.image;
    }

    const hash = metaJson.image.match(ipfsHashRegex)?.[0];
    if (!hash) {
      return '';
    }

    return `${IPFS_PREFIX}${hash}`;
  })();

  return {
    ipfsImageLink: ipfsImage,
    address: poolAddress,
    name: metaJson.name,
    description: metaJson.description,
    externalLink: metaJson.external_link,
  };
}
